<app-alert></app-alert>
<div class="home-dashbaords">
    <div class="card home-dashbaord" [routerLink]="['/orders/orders-list']" (click)="sharedService.mp3SielnceNotification()">
        <div class="card-body">
            <div class="order-card-content">
                <div class="right">
                    <i class="fas fa-shopping-basket"></i>
                </div>
                <div class="left">
                    <div class="top">{{ dashboardReport.ordersToday }}</div>
                    <div class="bottom">Orders today</div>
                </div>
            </div>
        </div>
    </div>
    <div class="card home-dashbaord" [routerLink]="['/orders/orders-list']" (click)="sharedService.mp3SielnceNotification()">
        <div class="card-body">
            <div class="order-card-content">
                <div class="right">
                    <i class="fal fa-times"></i>
                </div>
                <div class="left">
                    <div class="top">{{ dashboardReport.cancelledToday }}</div>
                    <div class="bottom">Cancelled orders today</div>
                </div>
            </div>
        </div>
    </div>
    <div class="card home-dashbaord" [routerLink]="['/management/complain-list']" (click)="sharedService.mp3SielnceNotification()">
        <div class="card-body">
            <div class="order-card-content">
                <div class="right">
                    <i class="fa fa-comments"></i>
                </div>
                <div class="left">
                    <div class="top">{{ dashboardReport.complainsToday }}</div>
                    <div class="bottom">Complains Today</div>
                </div>
            </div>
        </div>
    </div>
</div>
